import { render, staticRenderFns } from "./GenericHeader.vue?vue&type=template&id=6204e027&"
import script from "./GenericHeader.vue?vue&type=script&lang=js&"
export * from "./GenericHeader.vue?vue&type=script&lang=js&"
import style0 from "./GenericHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports